import ApiBase from '@pulse/services/ApiBase';

export default class WhitelabelService extends ApiBase {
  constructor(apiBaseUrl) {
    super(apiBaseUrl);
  }

  async find(hostname = window?.location?.hostname, storeId) {
    if (!hostname && !storeId) {
      return {};
    }

    const { data } = await this.client.get('customer-portal/whitelabel/settings', {
      params: {
        domain: hostname,
        store: storeId,
      },
    });

    return data;
  }
}
